'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setContext = setContext;
exports.logError = logError;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function setContext() {
  return {
    type: _types2.default.logging.SET_CONTEXT
  };
}

function logError(error, extra) {
  return {
    type: _types2.default.logging.LOG_ERROR,
    error: error,
    extra: extra
  };
}